import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { BASE_URL } from '../context/api';

const AssessmentResults = () => {
  const { assessmentId } = useParams(); // Extract assessmentId from URL parameters
  const [assessmentInfo, setAssessmentInfo] = useState(null);
  const [studentResults, setStudentResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null); // Track API errors

  // Fetch assessment results based on assessmentId
  const fetchAssessmentResults = async () => {
    setLoading(true);
    setError(null); // Reset error before fetching
    try {
      const response = await axios.get(`${BASE_URL}/assessments-results/get-assessment-results/${assessmentId}`);
      setAssessmentInfo(response.data.assessmentInfo);
      setStudentResults(response.data.studentResults);
    } catch (error) {
      console.error('Error fetching assessment results:', error);
      setError('No student results found for this assessment.');
    } finally {
      setLoading(false);
    }
  };

  // Load assessment results when the component mounts
  useEffect(() => {
    fetchAssessmentResults();
  }, [assessmentId]);

  return (
    <div className="p-4">

      {/* Loading Indicator */}
      {loading && (
        <p className="text-center text-lg">Loading assessment results...</p>
      )}

      {/* Error Message */}
      {!loading && error && (
        <p className="text-center text-red-500 text-lg">{error}</p>
      )}

      {/* No results found */}
      {!loading && !error && studentResults.length === 0 && (
        <p className="text-center text-lg">No student results found for this assessment.</p>
      )}

      {/* Assessment Information */}
      {assessmentInfo && !loading && !error && (
        <div className="bg-pink-200 p-6 rounded-lg mb-6 shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <p><strong>Assessment Name:</strong> {assessmentInfo.AssessmentName}</p>
            <p><strong>Date Created:</strong> {new Date(assessmentInfo.DateCreated).toLocaleDateString()}</p>
            <p><strong>Due Date:</strong> {new Date(assessmentInfo.DateDue).toLocaleDateString()}</p>
            <p><strong>Class:</strong> {assessmentInfo.ClassName}</p>
            <p><strong>Form:</strong> {assessmentInfo.Form}</p>
            <p><strong>Term:</strong> {assessmentInfo.Term}</p>
            <p><strong>Year:</strong> {assessmentInfo.Year}</p>
            <p><strong>Teacher:</strong> {`${assessmentInfo.EmployeeName} ${assessmentInfo.EmployeeSurname}`}</p>
          </div>
          {/* Description in its own row */}
          <div className="p-4 mt-4 rounded-lg shadow">
            <p><strong>Description:</strong> {assessmentInfo.Description}</p>
          </div>
        </div>
      )}

      {/* Student Results List */}
      {studentResults.length > 0 && !loading && !error && (
        <div>
          <h2 className="text-xl font-bold mb-4">Student Results</h2>
          <table className="min-w-full bg-white shadow-md rounded">
            <thead>
              <tr>
                <th className="py-2 text-start px-4 border-b">Reg Number</th>
                <th className="py-2 text-start px-4 border-b">Student Name</th>
                <th className="py-2 text-start px-4 border-b">Mark</th>
              </tr>
            </thead>
            <tbody>
              {studentResults.map((student) => (
                <tr key={student.resultId}>
                  <td className="py-2 px-4 border-b">{student.regNumber}</td>
                  <td className="py-2 px-4 border-b">{`${student.studentName} ${student.studentSurname}`}</td>
                  <td className="py-2 px-4 border-b">{student.mark}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    </div>
  );
};

export default AssessmentResults;
